import { computed } from "vue-demi";
import useTheme from "./useTheme.mjs";
export default function useProps(componentName, componentProps) {
  const theme = useTheme();
  if (!theme)
    throw new Error(
      "No theme provided. You need to provide a theme config to Asbis UI plugin."
    );
  const componentSettings = computed(() => theme.components?.[componentName]);
  const currentProps = computed(
    () => componentSettings.value?.props ? {
      ...componentProps,
      ...componentSettings.value.props
    } : componentProps
  );
  return currentProps;
}
